import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import FeedFiltersEnabled from "%/dynamic-component-editor/options/feed-filters-enabled";
import FeedFiltersSource from "%/dynamic-component-editor/options/feed-filters-source";
import FilterLabelText from "%/dynamic-component-editor/options/filter-label-text";
import FilterIcon from "%/dynamic-component-editor/options/filter-icon";
import FilterToolbarAlignment from "%/dynamic-component-editor/options/filter-toolbar-alignment";
import FilterToolbarLabelPosition from "%/dynamic-component-editor/options/filter-toolbar-label-position";
import FilterToolbarBackgroundColor from "%/dynamic-component-editor/options/filter-toolbar-background-color";
import FilterToolbarFontColor from "%/dynamic-component-editor/options/filter-toolbar-font-color";
import FilterToolbarUnselectedFontColor from "%/dynamic-component-editor/options/filter-toolbar-unselected-font-color";
import FilterToolbarIconColor from "%/dynamic-component-editor/options/filter-toolbar-icon-color";
import FilterToolbarPadding from "%/dynamic-component-editor/options/filter-toolbar-padding";
import FilterToolbarMargins from "%/dynamic-component-editor/options/filter-toolbar-margins";

// Filter chips above the feed. The styling options are the SAME FilterToolbar*
// classes FeedV1's toolbar already uses, so a destination that has styled one
// filter row has styled both. Following feed-separators-options, the toolset
// renders the on/off switch and only the settings that apply when it is on.
export default class FeedFiltersOptions extends BaseOptionsBundle {

  optionTitle = "Filters";
  static optionClassName = "i-feed-filters";
  inspectorToolGroup = "feedFilters";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.FEED_FILTERS_TOOL_SET,
  };

  constructor(values = {}) {
    super(values, [
      new FeedFiltersEnabled(),
      new FeedFiltersSource(),
      new FilterLabelText(),
      new FilterIcon(),
      new FilterToolbarAlignment(),
      new FilterToolbarLabelPosition(),
      new FilterToolbarBackgroundColor(),
      new FilterToolbarFontColor(),
      new FilterToolbarUnselectedFontColor(),
      new FilterToolbarIconColor(),
      new FilterToolbarPadding(),
      new FilterToolbarMargins(),
    ]);
  }
}
